import React from 'react'

export default ({ x, y, radius }) => (
    <circle className='ball' cx={x} cy={y} r={radius} />
)